import { StarFilled } from '@ant-design/icons';
import { Tag } from 'antd';
import styles from 'styles/components/newOpportunityBadge.module.scss';

const NewOpportunityBadge = ({ style = {} }) => (
  <Tag className={styles.newOpportunity} style={style}>
    <StarFilled style={{ marginRight: 4, fontSize: 12 }} />
    NEW
  </Tag>
);

export default NewOpportunityBadge;
